import { render, staticRenderFns } from "./RegisterDriver.vue?vue&type=template&id=60ba900e&scoped=true"
import script from "./RegisterDriver.vue?vue&type=script&lang=js"
export * from "./RegisterDriver.vue?vue&type=script&lang=js"
import style0 from "./RegisterDriver.vue?vue&type=style&index=0&id=60ba900e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ba900e",
  null
  
)

export default component.exports